import { NgModule } from '@angular/core';
import { PopupService } from '@local/ui-infra';
import { SharedModule } from '@shared/shared.module';
import { ResultsModule } from '../../../results/results.module';
import { FilePreviewModule } from '../../../preview/file-preview/file-preview.module';
import { CollectionsPageModule } from '../../../collections-page/collections-page.module';
import { AssistantHeaderLineComponent } from './components/assistant-header-line/assistant-header-line.component';
import { AssistantComponent } from './components/assistant/assistant.component';
import { AssistantsEmptyStateComponent } from './components/assistants-empty-state/assistants-empty-state.component';
import { AssistantsGuideComponent } from './components/assistants-guide/assistants-guide.component';
import { AssistantsComponent } from './components/assistants/assistants.component';
import { SlackPreferencesComponent } from './components/slack-preferences/slack-preferences.component';
import { SpecificResourcePopupComponent } from './components/specific-resource-popup/specific-resource-popup.component';
import { AssistantPopupService } from './services/assistant-popup.service';
import { AssistantFilterButtonsComponent } from './components/assistant-filter-buttons/assistant-filter-buttons.component';
import { TeamsPreferencesComponent } from './components/teams-preferences/teams-preferences.component';
import { QuestionnaireSectionComponent } from './components/questionnaire-section/questionnaire-section.component';
import { AssistantViewHelper } from './helpers/assistant-view-helper';
import { GeneralPreferencesComponent } from './components/general-preferences/general-preferences.component';
import { RfpPreferencesComponent } from './components/rfp-preferences/rfp-preferences.component';
import { AssistantKnowledgeComponent } from './components/assistant-knowledge/assistant-knowledge.component';
import { AssistantInstructionsModule } from './modules/assistant-instructions/assistant-instructions.module';
import { SlackCustomizationInputsListComponent } from './components/slack-customization-inputs-list/slack-customization-inputs-list.component';
import { SlackActionButtonsPopupComponent } from './components/slack-action-buttons-popup/slack-action-buttons-popup.component';
import { BotBehaviorComponent } from './components/bot-behavior/bot-behavior.component';

const components = [
  AssistantComponent,
  SlackPreferencesComponent,
  TeamsPreferencesComponent,
  GeneralPreferencesComponent,
  RfpPreferencesComponent,
  AssistantsComponent,
  AssistantsEmptyStateComponent,
  AssistantsGuideComponent,
  AssistantHeaderLineComponent,
  SpecificResourcePopupComponent,
  AssistantFilterButtonsComponent,
  QuestionnaireSectionComponent,
  AssistantKnowledgeComponent,
  SlackCustomizationInputsListComponent,
  SlackActionButtonsPopupComponent,
  BotBehaviorComponent,
];

@NgModule({
  declarations: components,
  imports: [ResultsModule, FilePreviewModule, SharedModule, CollectionsPageModule, AssistantInstructionsModule],
  providers: [{ provide: PopupService, useClass: PopupService }, AssistantPopupService, AssistantViewHelper],
  exports: components,
})
export class AssistantPageModule {}
